
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'companyApprove'
})
export default class companyApprove extends Vue {

  toPage() {
    this.$router.push('/companyInfoForm?formPage=h5')
  }
}
